const MetricTypes = {
    MAJESTIC: 'MAJESTIC',
    MOZ: 'MOZ',
    SOCIAL: 'SOCIAL',
    OTHER: 'OTHER',
};

export default MetricTypes;
